<template>
  <el-dialog
    title="添加收款"
    :visible.sync="visible"
    :close-on-click-modal="false"
    :before-close="handleClose"
    @open="handleOpen"
    width="40%"
    top="8vh"
  >
    <div>
      <el-form ref="ruleForm" :model="form" label-width="120px" :rules="rules">
        <el-form-item label="业务订单号:" class="mt-0">{{receiptData.orderNumber}}</el-form-item>
        <el-form-item label="采购商编号:" class="mt-0">{{receiptData.recBusinessNo}}</el-form-item>
        <el-form-item label="采购商名称:" class="mt-0">{{receiptData.recBusinessName}}</el-form-item>
        <el-form-item label="应收单金额:" class="mt-0">{{receiptData.shouldRecAmount | toFenThousandsAndFloat}}元</el-form-item>
        <el-form-item label="待收款金额:" class="mt-0">{{receiptData.waitRecAmount | toFenThousandsAndFloat}}元</el-form-item>
        <el-form-item label="选择收款账户:" prop="bankAccountNo">
          <el-select
            v-model="form.bankAccountNo"
            placeholder="请输入账户名称或编号搜索"
            popper-class="select-account"
            style="width: 100%"
            :popper-append-to-body="false"
            filterable
            remote
            :remote-method="remoteMethod"
          >
            <el-option
              v-for="(item, index) in searchBakAcctList"
              :key="index"
              :label="item.accountNumber"
              :value="item.bankAccountNo"
            >
              <div class="content">
                <div class="content-l">
                  <div class="l-top">
                    <div class="name" :class="[item.accountName.length >= 20 ? 'flex-style' : '']">{{item.accountName}}</div>
                    <span v-if="item.bankAccountType !== 3">
                      {{item.bankName}}
                      <span class="tip-text" v-if="item.bankAccountType">({{item.bankAccountType === 1 ? '对私' : '对公'}})</span>
                    </span>
                  </div>
                  <div class="acconut">{{item.accountNumber}}</div>
                </div>
              </div>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="本次收款金额:" prop="receiptAmount">
          <el-input
            placeholder="请输入"
            v-model="form.receiptAmount"
            v-number-only:2="form.receiptAmount"
          />
        </el-form-item>
        <el-form-item label="上传转账凭证:" prop="certificate">
          <template>
            <upload
              accept=".jpg, .jpeg, .png,.pdf"
              :limit="999"
              path="receipt/offline/"
              :file-list="form.certificate"
              :uploading.sync="uploading"
              @update="handleUploadUpdate"
              @upload-paste="handleUploadPaste"
            />
            <div class="upload-tip">图片大小不得超过5M</div>
          </template>
        </el-form-item>
      </el-form>
    </div>
    <span
      slot="footer"
      class="dialog-footer"
    >
      <el-button
        @click="handleClose()"
        :size="formSize"
      >取消</el-button>
      <el-button
        type="primary"
        :size="formSize"
        @click="submit()"
        :disabled="uploading"
      >确认</el-button>
    </span>
  </el-dialog>
</template>

<script>
import Upload from '@/components/upload';
import { addReceipt, getAakAcctList } from '@/api/receivables/receive';
import { regFenToYuan, regYuanToFen, formatFloat } from '@/utils/number';

export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    receiptData: {
      type: Object,
      default: () => ({}),
    },
  },
  components: { Upload },
  data() {
    const validateAmount = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入本次收款金额'));
      } else if (Number(value) > regFenToYuan(this.receiptData.waitRecAmount ?? 0)) {
        callback(new Error('收款金额不能大于待收金额'));
      } else {
        callback();
      }
    };
    const validatePicUrl = (rule, value, callback) => {
      if (!this.form.certificate || this.form.certificate.length === 0) {
        callback(new Error('请上传凭证'));
      } else {
        callback();
      }
    };

    return {
      uploading: false,
      form: {
        receiptAmount: '',
        certificate: [],
        bankAccountNo: '',
      },
      rules: {
        receiptAmount: [
          { required: true, message: '请输入本次收款金额', trigger: 'blur' },
          { validator: validateAmount, trigger: 'blur' },
        ],
        bankAccountNo: [
          { required: true, message: '请选择收款账户', trigger: 'change' },
        ],
        certificate: [
          { required: true, message: '请上传凭证', trigger: 'blur' },
          { validator: validatePicUrl, trigger: 'blur' },
        ],
      },
      bakAcctList: [], // 收款账户
      searchBakAcctList: [], // 搜索收款账户列表
    };
  },
  methods: {
    // 关闭
    handleClose() {
      this.$refs.ruleForm.resetFields();
      this.$emit('update:visible', false);
    },
    // 打开窗口前
    handleOpen() {
      this.$nextTick(() => {
        this.form = {
          receiptAmount: formatFloat(regFenToYuan(this.receiptData.waitRecAmount ?? 0)),
          certificate: [],
          bankAccountNo: '',
        };
        this._getAakAcctList();
      });
    },
    // 提交
    submit() {
      this.$refs.ruleForm.validate(async (valid) => {
        if (valid) {
          const { certificate, receiptAmount, bankAccountNo } = this.form;
          const certificates = certificate.map((it) => it.fileId);
          const obj = {
            1: 'XJBANK',
            2: 'XJBANK',
            3: 'XJALIPAY',
            4: 'XJWECHAT',
          };
          const [receiptTypeItme] = this.bakAcctList.filter((el) => el.bankAccountNo === bankAccountNo);
          const { receiveNo, orderNumber, type } = this.receiptData;
          await addReceipt({
            receiveNo, // 应收单号
            receiptType: obj[receiptTypeItme.payBankAccountType], // 收款渠道
            receiptAmount: regYuanToFen(receiptAmount), // 本次收款金额 单位 分
            certificate: certificates.join(), // 转账凭证
            bankAccountNo, // 收款账号编号
            orderNumber,
            type, // 应收类型
          });
          this.$message.success('添加收款成功！');
          this.$emit('success');
          this.handleClose();
        }
      });
    },
    _getAakAcctList() {
      getAakAcctList({
        accountCategory: '',
        principalType: 1, // 0平台 1服务商
      }).then((res) => {
        this.bakAcctList = res.data || [];
        this.searchBakAcctList = res.data || [];
      });
    },
    // 图片上传返回
    handleUploadUpdate(images) {
      this.form.certificate = (images || []).map((item) => (item));
      this.$refs.ruleForm.validateField('certificate');
    },
    // 图片粘贴返回
    handleUploadPaste(image) {
      this.form.certificate.push(image);
      this.$refs.ruleForm.validateField('certificate');
    },
    remoteMethod(query) {
      if (query !== '') {
        const reg = new RegExp(query);
        this.searchBakAcctList = this.bakAcctList.filter((el) => {
          return reg.test(el.accountName) || reg.test(el.accountNumber);
        });
      } else {
        this.searchBakAcctList = this.bakAcctList;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep {
  .el-dialog {
    min-width: 550px;
  }
  .el-radio__input {
    .el-radio__inner {
      display: none;
    }
  }
  .select-account {
    .el-select-dropdown__item {
      height: auto;
    }
    .content {
      padding: 10px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-family: PingFangSC-Medium, PingFang SC;
      color: #4d4f51;
      .content-l {
        width: 100%;
        .l-top {
          display: flex;
          align-items: center;
        }
        .tip-text {
          margin-left: 0;
        }
        .name {
          font-weight: 500;
          line-height: 20px;
        }
        .flex-style {
          flex: 1;
        }
        span {
          color: #828487;
          font-weight: 400;
          font-size: 12px;
          margin-left: 12px;
          line-height: 18px;
        }
        .acconut {
          margin-top: 8px;
        }
      }
      .content-r {
        font-size: 10px;
        color: #c9ccd1;
        line-height: 14px;
      }
    }
  }
}
.mt-0 {
  margin-bottom: 0 !important;
}
.el-radio-group {
  display: flex;
  .el-radio {
    text-align: center;
    display: flex;
    margin: 0;
    .radio-content {
      display: flex;
      align-items: center;
      .text {
        margin-left: 5px;
      }
    }
  }
}

.el-radio.is-bordered.is-checked {
  background-color: #ecf2ff;
}
</style>
